import { getChainReactionState } from './chainReaction';
import './ChainReaction.css';
import CoreboundIcon from './CoreboundIcon';

const ChainReactionControl = ({ game }) => {
  const state = getChainReactionState(game);
  if (!state.owned) return null;
  return (
    <div className={`coreboundChainSetup ${state.available ? 'is-ready' : ''}`}>
      <div>
        <strong>
          <CoreboundIcon name="chainReaction" /> Chain Reaction{' '}
          <small>EPIC · AUTOMATIC</small>
        </strong>
        <span role="status">
          {state.used
            ? 'Used · One activation per run'
            : 'Automatic on your next throw · One use for the entire run'}
        </span>
        <span>
          Good and bad tiles both trigger. No diagonals or repeat chains.
        </span>
      </div>
    </div>
  );
};

export default ChainReactionControl;
